import type { WalletProvider } from '@dynamic-labs-sdk/client/core';

import type { SolanaWalletProvider } from '../SolanaWalletProvider.types';

export const isSolanaWalletProvider = (
  provider: WalletProvider
): provider is SolanaWalletProvider => {
  return provider.chain === 'SOL';
};
